export const ORDER_STATUS = {
    placed:      { label: "Order Placed",      className: "status-placed" },
    accepted:    { label: "Order Accepted",    className: "status-accepted" },
    inprogress:  { label: "Work in Progress",  className: "status-progress" },
    shipped:     { label: "Shipped",           className: "status-shipped" },
    cancelled:   { label: "Cancelled",         className: "status-cancelled" }
};